import { useSelector } from 'react-redux';
import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
  Zoom,
  DialogActions,
  CircularProgress,
} from '@mui/material';
import React, { useState } from 'react';
import { toast } from 'react-toastify';

import { API_BASE_URL } from '../../../../utils/env';

const DeactivateModal = ({
  openDeactivateDialog,
  deactivateMemberCloseDialog,
  selectedUserId,
  setSelectedUserId,
  setUsers,
  setDeactivatedMembers,
  USERLIST,
  setDeactivatedMembersError,
}) => {
  const [loading, setLoading] = useState(false);
  const { userInfo } = useSelector((state) => state.auth);
  const token = userInfo.token;

  const DeactivateMember = async () => {
    const url = `${API_BASE_URL}/Member/ActivateMember?id=${selectedUserId}&isActivate=false`;

    try {
      setLoading(true);

      const response = await fetch(url, {
        method: 'PATCH',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      // Get the deactivated member from USERLIST
      const deactivatedMember = USERLIST.find((user) => user.memberId === selectedUserId);

      // Handle successful response
      toast.success('Member deactivated successfully');

      // Update USERLIST by removing the deactivated member
      setUsers((prevUsers) => prevUsers.filter((user) => user.memberId !== selectedUserId));

      // Update deactivatedMembers by adding the deactivated member
      setDeactivatedMembers((prevDeactivatedMembers) => [...prevDeactivatedMembers, deactivatedMember]);

      // clear the selected user ID
      setSelectedUserId(null);
      // clear the error from the table if it was empty (ux)
      setDeactivatedMembersError(null);

      deactivateMemberCloseDialog();
    } catch (error) {
      console.error('Error deactivating member:', error.message);
      toast.error(`Error deactivating member: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Dialog prompt for deactivate member */}
      <Dialog
        open={openDeactivateDialog}
        onClose={deactivateMemberCloseDialog}
        aria-labelledby="deactivate-member-dialogue"
      >
        <DialogTitle id="deactivate-dialog-title">{'Deactivate member?'}</DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Deactivating this member will erase member details and attendance history. Deactivated members data will
            however be preserved for 12 weeks before being permanently erased.
          </DialogContentText>
        </DialogContent>

        {/* ACTION BUTTONS */}
        <DialogActions>
          <Button onClick={deactivateMemberCloseDialog} sx={{ color: '#4B4B8E' }}>
            Cancel
          </Button>
          <Tooltip
            placement="top"
            TransitionComponent={Zoom}
            title=" Please note that deactivation is reversible, and the member can be reactivated later
              if needed."
          >
            <Button onClick={DeactivateMember} sx={{ color: '#000080' }} disabled={loading}>
              {loading ? <CircularProgress size={24} color="inherit" /> : 'Deactivate'}
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeactivateModal;
